module.exports = {"TXTWCL_Read_more":{"id":"TXTWCL_Read_more","defaultMessage":"Ler mais"}}